import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useIsAuthenticate from "../hooks/useIsAuthenticate";
const redrecturls = { A: "admin", M: "madmin" };
export function PublicRoute({ component, ...rest }) {
  const { isAuthenticate, userType } = useIsAuthenticate();

  return !isAuthenticate ? <Outlet /> : <Navigate to={redrecturls[userType]} />;
}
